import pipe from 'lodash/fp/pipe';
import { isBrowser } from '../conditions';
import { toQueryString } from '../router';
import { devLoggerDeepLink } from '../devLogger';

const DEEPLINK_BASE = 'zigzag://open';

export const callDeepLink = (path: string) =>
  pipe(devLoggerDeepLink(path), query => {
    if (!isBrowser()) {
      return console.warn('Should invoke callDeepLink in client');
    }

    const normalizedPath = normalizePath(path)
    const queryString = toQueryString(query);
    const handledPath = (!normalizedPath.startsWith('/') ? '/' : '') + normalizedPath;
    const handledQuery = queryString ? '?' + queryString : '';
    const deeplinkUrl = `${DEEPLINK_BASE}${handledPath}${handledQuery}`;
    
    window.location.assign(deeplinkUrl);
  });


function normalizePath(path: string) {
  const prefixes = ['/open/', 'open/'];

  for (const prefix of prefixes) {
    if (path.startsWith(prefix)) {
      return path.slice(prefix.length);
    }
  }
  return path;
}